// src/components/ForecastVisibilityGraph.js

import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { AppBar, Toolbar, Typography, Box, Paper, Button } from "@mui/material"; // No longer need ToggleButtonGroup
import ImpressionMetricsView from "./ImpressionMetricsView";
import SnapshotView from "./SnapshotView";
import ForecastVisibilityGraph from "../ForecastVisibilityGraph"; // Import the new component
// Placeholder components for the other main views
const AttentionMetricsView = () => <Box sx={{ p: 4, minHeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Typography variant="h4">Attention Metrics View</Typography></Box>;


const ImpressionGraphs = () => {
  const { id } = useParams();
  const [selectedMainView, setSelectedMainView] = useState("snapshot");

  // An array to define our buttons, making the code cleaner
  const mainViews = [
    { key: "snapshot", label: "Snapshot" },
    { key: "attention", label: "Attention Metrics" },
    { key: "impression", label: "Impression Metrics" },
  ];

  return (
    <Box sx={{ backgroundColor: '#f7f7f7', minHeight: '100vh' }}>
      {/* Header */}
      <AppBar position="static" sx={{ backgroundColor: '#ff9800' }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Calculated  Impression Graphs
          </Typography>
        </Toolbar>
      </AppBar>

      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, my: 3 }}>
        {mainViews.map((view) => (
          <Button
            key={view.key}
            variant={selectedMainView === view.key ? "contained" : "outlined"}
            onClick={() => setSelectedMainView(view.key)}
            sx={{
              borderRadius: "8px",
              textTransform: 'none',
              px: 3,
              py: 1,
              borderWidth: '1.5px',
              '&:hover': {
                borderWidth: '1.5px',
              }
            }}
          >
            {view.label}
          </Button>
        ))}
      </Box>

      {/* Content Display Area */}
      <Box sx={{ mx: 4, mb: 4 }}>
        <Paper elevation={3} sx={{ borderRadius: '16px', overflow: 'hidden' }}>
          {selectedMainView === 'snapshot' && <SnapshotView billboardId={id} />}
          {selectedMainView === 'attention' && <ForecastVisibilityGraph />}
          {selectedMainView === 'impression' && <ImpressionMetricsView billboardId={id} />}
        </Paper>
      </Box>
    </Box>
  );
};

export default ImpressionGraphs;